import { get, del, post, put } from '@api/request';

export async function fetchEventForms({ eventService }, authenticationToken) {
  const url = `${eventService}/events/peventforms`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEconomicUnitEventForms(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/events/peventforms?dataObject=economic unit`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPropertyEventForms(
  { eventService },
  authenticationToken,
) {
  const url = `${eventService}/events/peventforms?dataObject=property`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteEventForm(
  { eventService },
  authenticationToken,
  { payload: { formID } },
) {
  const url = `${eventService}/events/peventform/${formID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function canDeleteEventForm(
  { eventService },
  authenticationToken,
  { payload: { formID } },
) {
  const url = `${eventService}/events/peventform/${formID}/candelete`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function duplicateEventForm(
  { eventService },
  authenticationToken,
  { payload: { formID } },
) {
  const url = `${eventService}/events/peventform/${formID}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function createEventForm(
  { eventService },
  authenticationToken,
  { payload },
) {
  const url = `${eventService}/events/peventforms`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateEventForm(
  { eventService },
  authenticationToken,
  { payload },
) {
  const url = `${eventService}/events/peventform/${payload.formID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchDataObjects({ eventService }, authenticationToken) {
  const url = `${eventService}/events/dataobjects`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEventGroups({ eventService }, authenticationToken) {
  const url = `${eventService}/events/codefiles?type=event&name=group`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEventForm(
  { eventService },
  authenticationToken,
  { payload: { formID } },
) {
  const url = `${eventService}/events/peventform/${formID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateFormFields(
  { eventService },
  authenticationToken,
  { payload },
) {
  const url = `${eventService}/events/peventform/${payload.formID}/formfields`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function updateEventTypes(
  { eventService },
  authenticationToken,
  { payload },
) {
  const url = `${eventService}/events/peventform/${payload.formID}/eventtypes`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchFormTags(
  { eventService },
  authenticationToken,
  { payload: { formID } },
) {
  const url = `${eventService}/events/peventform/${formID}/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEventFormsByType(
  { eventService },
  authenticationToken,
  { payload: { type } },
) {
  const url = `${eventService}/events/peventforms?dataObject=${type}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEventFormPublishedTypes(
  { eventService },
  authenticationToken,
  { formID },
) {
  const url = `${eventService}/events/peventform/${formID}/publishtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEventFormUnPublishedTypes(
  { eventService },
  authenticationToken,
  { formID },
) {
  const url = `${eventService}/events/peventform/${formID}/unpublishedeventtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function publishEventFormUnPublishedTypes(
  { eventService },
  authenticationToken,
  { formID, payload },
) {
  const url = `${eventService}/events/peventform/${formID}/publishtypes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteEventFormPublishedType(
  { eventService },
  authenticationToken,
  { publishID },
) {
  const url = `${eventService}/events/peventformpublishtype/${publishID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
